module.exports = __webpack_public_path__ + "bs.54ca6c7aa68e1ecfcdff.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bs.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bs.svg
// module chunks = styles